import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { flexRender } from '@tanstack/react-table';

export function DataTableMobile({
  table,
  loading = false,
  emptyMessage = 'No hay registros',
  onRowClick = () => {},
}) {
  const rows = table.getRowModel().rows;

  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const renderCell = (cell) => {
    const cellDefinition = cell.column.columnDef;

    if (cellDefinition.cell) {
      return flexRender(cellDefinition.cell, cell.getContext());
    }

    return String(cell.getValue() ?? '');
  };

  if (loading) {
    return (
      <div className="datatable-mobile-message">
        Cargando...
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div className="datatable-mobile-message">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="datatable-mobile-container">
      {rows.map((row) => {
        const isExpanded = !!expandedRows[row.id];

        // Siempre toma la primera columna
        const allCells = row.getAllCells();
        const firstCell = allCells[0];

        return (
          <div
            key={row.id}
            className="datatable-mobile-card"
            onClick={() => onRowClick(row.original)}
          >
            {/* ENCABEZADO */}
            <div className="datatable-mobile-header">

              {/* PRIMERA COLUMNA */}
              <div className="datatable-mobile-folio">
                <div className="datatable-mobile-label">
                  {typeof firstCell?.column.columnDef.header === 'string'
                    ? firstCell.column.columnDef.header
                    : firstCell?.column.id}
                </div>

                <div className="datatable-mobile-folio-value">
                  {firstCell && renderCell(firstCell)}
                </div>
              </div>

              {/* BOTÓN DESPLEGAR */}
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation();
                  toggleRow(row.id);
                }}
                className="datatable-mobile-expand-button"
                aria-label={
                  isExpanded
                    ? 'Ocultar información'
                    : 'Mostrar información'
                }
              >
                {isExpanded ? (
                  <FaChevronUp className="datatable-mobile-icon" />
                ) : (
                  <FaChevronDown className="datatable-mobile-icon" />
                )}
              </button>
            </div>

            {/* TODAS LAS COLUMNAS */}
            {isExpanded && (
              <div className="datatable-mobile-details">
                {allCells.map((cell) => {
                  const label =
                    typeof cell.column.columnDef.header === 'string'
                      ? cell.column.columnDef.header
                      : cell.column.id;

                  return (
                    <div
                      key={cell.id}
                      className="datatable-mobile-detail-row"
                    >
                      <span className="datatable-mobile-detail-label">
                        {label}
                      </span>

                      <div className="datatable-mobile-detail-value">
                        {renderCell(cell)}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default DataTableMobile;